// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Brand from './components/Brand';
import About from './components/About';
import Work from './components/Work';
import Testimonial from './components/Testimonial';
import './animations.css';
import './index.css';
import Footer from './components/Footer';
import Workimg from './components/Workimg';  // Corrected import
import Galleryimg from './components/Gallery';  // Corrected import

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<>
          <Home />
          <Brand />
          <Testimonial />
        </>} />
        <Route path="/about" element={<About />} />
        <Route path="/work" element={<>
          <Work />
          <Workimg />
          <Galleryimg />
        </>} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
